import { render, staticRenderFns } from "./IconesDaToolbarPadroes.vue?vue&type=template&id=40a529b2&"
import script from "./IconesDaToolbarPadroes.vue?vue&type=script&lang=ts&"
export * from "./IconesDaToolbarPadroes.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports